import { Color } from '@nect/ui/theme/color';
// eslint-disable-next-line import/named
import styled, { DefaultTheme } from 'styled-components';

import { TextBodySmallCSS, TextFootnoteSmallCSS } from '../text/text.styled';
import { InputState } from '.';

export interface IInputStyledProps {
    $state: InputState;
    disabled?: boolean;
}

export const statusColour = ({
    $state,
    theme,
    disabled,
}: {
    $state: InputState;
    theme: DefaultTheme;
    disabled?: boolean;
}): string => {
    let colour = Color.grey300;

    if (disabled) {
        colour = Color.grey100;
    } else if ($state === 'valid') {
        colour = Color.snackSuccessBase;
    } else if ($state === 'invalid') {
        colour = Color.snackErrorBase;
    } else if ($state === 'warning') {
        colour = Color.snackWarning1Base;
    }

    return theme.color[colour];
};

const ContainerStyled = styled.div<IInputStyledProps>`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    position: relative;
    gap: ${({ theme }) => theme.spacing.XXS};

    box-shadow: ${({ $state, theme, disabled }) =>
        `inset 0 0 0 ${$state === 'default' ? 1 : 2}px ${statusColour({
            $state,
            theme,
            disabled,
        })}`};
    border-radius: ${({ theme }) => theme.borderRadius.XS};
    padding: ${({ theme }) => `0 ${theme.spacing.S}`};
    height: ${({ theme }) => theme.spacing.XL};

    &:focus-within {
        box-shadow: inset 0 0 0 1px
                ${({ theme }) => theme.color[Color.snackInfoBase]},
            0 0 0 2px rgba(10, 108, 255, 0.08);
    }

    &:hover {
        box-shadow: inset 0 0 0 1px
            ${({ theme, disabled }) =>
                theme.color[disabled ? Color.grey100 : Color.grey700]};
    }

    background-color: ${({ theme, disabled }) =>
        disabled ? theme.color[Color.grey100] : theme.color[Color.white100]};
`;

const InputStyled = styled.input<IInputStyledProps>`
    ${TextBodySmallCSS}

    border: 0;
    outline: 0;
    background: transparent;
    flex-grow: 1;

    &::placeholder {
        color: ${({ theme }) => theme.color[Color.grey500]};
    }
`;

const FeedbackStyled = styled.p<IInputStyledProps>`
    ${TextFootnoteSmallCSS}

    position: absolute;
    top: 44px;
    left: 0;
    color: ${({ $state, theme, disabled }) =>
        statusColour({
            $state,
            theme,
            disabled,
        })};
`;

// eslint-disable-next-line import/no-default-export
export default {
    ContainerStyled,
    InputStyled,
    FeedbackStyled,
};
